export default __webpack_public_path__ + "static/media/bubble_bg.5e6b80d3.svg";